import { render, staticRenderFns } from "./baiFang.vue?vue&type=template&id=1e91bc08&scoped=true"
import script from "./baiFang.vue?vue&type=script&lang=js"
export * from "./baiFang.vue?vue&type=script&lang=js"
import style0 from "./baiFang.vue?vue&type=style&index=0&id=1e91bc08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e91bc08",
  null
  
)

export default component.exports